import React from 'react';

export default () => (
    <svg viewBox="2 2 12 12" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" fill="currentColor" />
    </svg>
);
